import { render, staticRenderFns } from "./PurchaseContract.vue?vue&type=template&id=56b93aeb&scoped=true"
import script from "./PurchaseContract.vue?vue&type=script&lang=ts"
export * from "./PurchaseContract.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseContract.vue?vue&type=style&index=0&id=56b93aeb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b93aeb",
  null
  
)

export default component.exports